module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./StudyMapView.js"));
	}, "StudyMapView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StudyMapView!./src/pages/Learn/My/StudyMap/StudyMapView.js
// module id = 1239
// module chunks = 431